import { Pressable, Text, View } from "react-native";
import {
  ChevronRight,
  Plus,
  TestTube2,
  type LucideIcon,
} from "lucide-react-native";
import { useTranslations } from "@src/packages/i18n";
import { GLASS_CARD_STYLE } from "@louise/moon-ui/theme/tokens";

import {
  pressLabel,
  usePressCapture,
} from "@src/packages/analytics/usePressCapture";
function ResultActionButton({
  label,
  icon: Icon,
  onPress,
  trailingIcon: TrailingIcon,
}: {
  label: string;
  icon: LucideIcon;
  onPress: () => void;
  trailingIcon?: LucideIcon;
}) {
  const capturePress = usePressCapture("ResultActionButton");
  return (
    <Pressable
      onPress={() => {
        capturePress(pressLabel(label), "test_result_action");
        onPress();
      }}
      accessibilityRole="button"
      accessibilityLabel={label}
      style={({ pressed }) => ({
        minHeight: 38,
        borderRadius: 999,
        paddingHorizontal: 12,
        paddingVertical: 9,
        backgroundColor: pressed
          ? "rgba(255,255,255,0.72)"
          : "rgba(255,255,255,0.48)",
        borderWidth: 1,
        borderColor: "rgba(92,52,32,0.1)",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        gap: 6,
        opacity: pressed ? 0.78 : 1,
      })}
    >
      <Icon size={13} color="#6E625B" strokeWidth={1.9} />
      <Text
        className="font-dm-sans"
        numberOfLines={1}
        style={{
          fontSize: 12.5,
          lineHeight: 16,
          color: "#6E625B",
          fontWeight: "800",
          textAlign: "center",
        }}
      >
        {label}
      </Text>
      {TrailingIcon ? (
        <TrailingIcon size={13} color="#6E625B" strokeWidth={1.9} />
      ) : null}
    </Pressable>
  );
}

export default function TestResultActionsCard({
  addResultDescription,
  getTestedDescription,
  onAddResult,
  onGetTested,
  t,
}: {
  addResultDescription: string;
  getTestedDescription: string;
  onAddResult: () => void;
  onGetTested: () => void;
  t: ReturnType<typeof useTranslations>;
}) {
  return (
    <View
      style={{
        ...GLASS_CARD_STYLE,
        borderRadius: 18,
        padding: 14,
      }}
    >
      <View style={{ gap: 8 }}>
        <Text
          className="font-dm-sans"
          style={{ fontSize: 13, lineHeight: 19, color: "#7D6F66" }}
        >
          {addResultDescription}
        </Text>
        <Text
          className="font-dm-sans"
          style={{ fontSize: 13, lineHeight: 19, color: "#7D6F66" }}
        >
          {getTestedDescription}
        </Text>
      </View>

      <View style={{ flexDirection: "row", gap: 8, marginTop: 14 }}>
        <View style={{ flex: 1 }}>
          <ResultActionButton
            label={t("access.testing.comparison.add_result")}
            icon={Plus}
            onPress={onAddResult}
          />
        </View>
        <View style={{ flex: 1 }}>
          <ResultActionButton
            label={t("access.testing.comparison.get_tested")}
            icon={TestTube2}
            trailingIcon={ChevronRight}
            onPress={onGetTested}
          />
        </View>
      </View>
    </View>
  );
}
